import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'branch',
  initialState: {
      currentDataItem: {},
      currentDataItemUpdated: false,
      applicationTypes: [],
      businessUnits: [],
      vendors: []
  },
  reducers: {
    setDataItem: (state, action) => {
      state.currentDataItem = action.payload;
      state.currentDataItemUpdated = false;
    },
    updateDataItem: (state, action) => {
      console.log(action);

      state.currentDataItem[action.payload.field] = action.payload.value;
      state.currentDataItemUpdated = true;

      console.log(state.currentDataItem);
    },
    saveDataItem: (state, action) => {
      state.currentDataItemUpdated = false;
    },
    saveApplicationTypes: (state, action) => {
      state.applicationTypes = action.payload.dataList.map(item => {
        return {text: item.displayName, value: item.id}
      });
    },
    saveBusinessUnits: (state, action) => {
      state.businessUnits = action.payload.dataList.map(item => {
        return {text: item.displayName, value: item.id}
      });
    },
    saveVendors: (state, action) => {
      state.vendors = action.payload.dataList.map(item => {
        return {text: item.displayName, value: item.id}
      });
    },
  }
})

// export actions
export const { setDataItem, updateDataItem, saveDataItem, 
  saveApplicationTypes, saveBusinessUnits, saveVendors } = slice.actions

// export reducer
export default slice.reducer